import axios from "axios";
import {API_URL} from "../constants";
import {authHeader} from "../Utilities";
import {TaskCid} from "./ApiModels/TaskCid";
import {JobProgress, JobProgressRaw} from "./ApiModels/JobProgress";
import {StatusCount} from "./ApiModels/BackgroundTasks";

export type ImportRunFromS3Params = {
    "run-name": string;
    "object-key": string;
    "auto-expose": boolean;
}

class ProjectsService {
    async importRunFromS3(projectId: string, params: ImportRunFromS3Params): Promise<TaskCid> {
        const response = await axios.post<TaskCid>(
            API_URL + `/projects/${projectId}/import_run_from_s3`,
            {...params}, {headers: authHeader()}
        );
        return response.data;
    }

    async importRunFromS3Progress(projectId: string, task: TaskCid): Promise<JobProgress> {
        const progress = await axios.get<JobProgressRaw>(
            API_URL + `/projects/${projectId}/import_run_from_s3/progress/${task}`,
            {headers: authHeader()}
        );
        return new JobProgress(progress.data);
    }

    async backgroundStatus(projectId: string): Promise<StatusCount[]> {
        const response = await axios.get<StatusCount[]>(
            API_URL + `/projects/${projectId}/background_status`,
            {headers: authHeader()}
        );
        return response.data;
    }
}

export default new ProjectsService();